import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, GithubIssueViewModel, SupportTicketFilter, SupportTicketSelectItem, SupportTicketViewModel, SupportTicketMetricsViewModel } from "../../core/api/models";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from "primeng/table";
import { TicketsApiService } from "../../core/api/services";
import { DomSanitizer } from "@angular/platform-browser";
import { formatDate } from "@angular/common";
import { trigger, state, style, transition, animate } from '@angular/animations';



@Component({
  selector: 'app-tickets-list-component',
  templateUrl: './tickets-list.component.html',
  styleUrl: './tickets-list.component.css',
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateY(0%)' }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(-100%)' }))
      ])
    ]),
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-180deg)' })),
      transition('rotated => default', animate('300ms ease-out')),
      transition('default => rotated', animate('300ms ease-in'))
    ])
  ],
  standalone: false
})
export class TicketsListComponent implements OnInit, AfterViewInit {
  public pageTitle: string = 'Support Tickets';

  selectedItems: SupportTicketViewModel[] | undefined = undefined;
  expandedRows: any = {};

  gitHubIssueVisible: boolean = false;
  loadingGitHubIssue: boolean = false;
  gitHubIssues: GithubIssueViewModel[] | null = null;
  gitHubIssue: GithubIssueViewModel | null = null;
  gitHubComment?: string;
  gitHubSelectedItems: SupportTicketViewModel[] | null = null;

  filter: any = {};
  list: any = undefined;
  tickets: any = undefined;
  loadingList: boolean = true;
  loading: boolean = false;
  // Ticket Categories
  unread: SupportTicketViewModel[] | null | undefined = [];
  bugs: SupportTicketViewModel[] | null | undefined = [];
  critical: SupportTicketViewModel[] | null | undefined = [];
  featureRequests: SupportTicketViewModel[] | null | undefined = [];
  misc: SupportTicketViewModel[] | null | undefined = [];
  all: SupportTicketViewModel[] | null | undefined = [];
  pinned: SupportTicketViewModel[] | null | undefined = [];
  criticalCount: number | null | undefined = 0;
  unreadCount: number | null | undefined = 0;
  bugCount: number | null | undefined = 0;
  featureRequestsCount: number | null | undefined = 0;
  miscCount: number | null | undefined = 0;
  // Ticket Metrics for display
  metrics: SupportTicketMetricsViewModel | null | undefined = null;
  showACRInfo: boolean = false;
  showDRTInfo: boolean = false;
  showACPInfo: boolean = false;

  // Filter options
  showFilter: boolean = true;
  showPinned: boolean = true;
  rotatedPinIcon: string = 'default';
  priorities: SupportTicketSelectItem[] | null | undefined = [];
  clients: SupportTicketSelectItem[] | null | undefined = [];
  types: SupportTicketSelectItem[] | null | undefined = [];

  // Filters
  submittedBy: string = "";
  closed: boolean = false;
  opened: boolean = true;
  waitingForResponse: boolean = false;
  updated: boolean = false;
  createdDateFrom: string = "";
  createdDateTo: string = "";
  ticketName: string = "";
  ticketID: number | null = null;
  priorityID: number | null = null;
  typeID: number | null = null;
  clientID: number | null = null;
  showTicketsWithNoResponse: boolean | null = false;
  showOnlyTicketsMissingGithubIssue: boolean | null = false;

  @ViewChild('dt1') table?: Table;

  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: TicketsApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      console.info('Loading ', params);
    });
    this.apiService.GetTicketFilterDropdowns()
      .forEach(
        (result) => {
          this.priorities = result.Priorities;
          this.clients = result.Clients;
          this.types = result.Types;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);
    this.refreshTickets();
  }

  ngAfterViewInit(): void {
  }

  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(
        (result) => {
          this.list = result;
          this.loadingList = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
          });
  }

  availablePriorities(): SupportTicketSelectItem[] {
    var prios: SupportTicketSelectItem[] = [];
    if (this.priorities != null) {
      prios = this.priorities;
    }
    return prios;
  }
  availableTypes(): SupportTicketSelectItem[] {
    var items: SupportTicketSelectItem[] = [];
    if (this.types != null) {
      items = this.types;
    }
    return items;
  }
  availableClients(): SupportTicketSelectItem[] {
    var items: SupportTicketSelectItem[] = [];
    if (this.clients != null) {
      items = this.clients;
    }
    return items;
  }

  formatPercentage(time: number | undefined) {
    if (time == null) {
      time = 0;
    }
    return `${(time * 100).toFixed(0)}%`;
  }

  formatDaysHoursMinutes(totalSeconds: number | undefined) {
    if (totalSeconds == null) {
      totalSeconds = 0;
    }
    const secondsInADay = 24 * 60 * 60;

    const days = Math.floor(totalSeconds / secondsInADay).toFixed(0);
    totalSeconds %= (24 * 3600);
    const hours = Math.floor(totalSeconds / 3600).toFixed(0);
    totalSeconds %= 3600;
    const minutes = Math.floor((totalSeconds % 3600) / 60).toFixed(0);

    const paddedDays = String(days).padStart(2, '0');
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${paddedDays}:${paddedHours}:${paddedMinutes}`;
  }

  formatHoursMinutes(totalSeconds: number | undefined) {
    if (totalSeconds == null) {
      totalSeconds = 0;
    }
    const hours = Math.floor(totalSeconds / 3600).toFixed(0);
    totalSeconds %= 3600;
    const minutes = Math.floor((totalSeconds % 3600) / 60).toFixed(0);
    const paddedHours = String(hours).padStart(2, '0');
    const paddedMinutes = String(minutes).padStart(2, '0');

    return `${paddedHours}:${paddedMinutes}`;
  }

  toggleShowACRInfo(value: boolean | null) {
    if (value == null)
      this.showACRInfo = !this.showACRInfo;
    else
      this.showACRInfo = value;
  }
  toggleShowDRTInfo(value: boolean | null) {
    if (value == null)
      this.showDRTInfo = !this.showDRTInfo;
    else
      this.showDRTInfo = value;
  }
  toggleShowACPInfo(value: boolean | null) {
    if (value == null)
      this.showACPInfo = !this.showACPInfo;
    else
      this.showACPInfo = value;
  }

  reload() {
    this.showTicketsWithNoResponse = false;
    this.refreshTickets();
  }

  doShowTicketsWithNoResponse() {
    if (this.showTicketsWithNoResponse == null)
      this.showTicketsWithNoResponse = true;
    else
      this.showTicketsWithNoResponse = !this.showTicketsWithNoResponse;
    this.loadTickets();
  }

  doShowOldestTicket() {
    if (this.metrics == null || this.metrics.OldestTicketID == null) {
      return;
    }
    this.openTicket(this.metrics.OldestTicketID);
  }

  refreshTickets() {
    this.loadMetrics();
    this.loadTickets();
  }

  loadMetrics() {
    this.apiService.GetTicketMetrics()
      .forEach(
        (result) => {
          this.metrics = result;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  loadTickets() {
    this.loading = true;
    var model: SupportTicketFilter = {
      PriorityID: this.priorityID,
      ClientID: this.clientID,
      TypeID: this.typeID,
      TicketID: this.ticketID,
      SubmittedBy: this.submittedBy,
      TicketName: this.ticketName,
      Closed: this.closed,
      Opened: this.opened,
      WaitingForResponse: this.waitingForResponse,
      Updated: this.updated,
      DateCreatedFrom: this.createdDateFrom,
      DateCreatedTo: this.createdDateTo,
      ShowTicketsWithNoResponse: this.showTicketsWithNoResponse,
      ShowOnlyTicketsMissingGithubIssue: this.showOnlyTicketsMissingGithubIssue
    }

    this.apiService.GetTickets({ body: model })
      .forEach(
        (result) => {
          this.unread = result.Unread;
          this.unreadCount = result.UnreadCount;
          this.critical = result.Critical;
          this.criticalCount = result.CriticalCount;
          this.featureRequests = result.FeatureRequests;
          this.featureRequestsCount = result.FeatureRequestsCount;
          this.misc = result.Misc;
          this.miscCount = result.MiscCount;
          this.all = result.All;
          this.bugs = result.Bugs;
          this.bugCount = result.BugCount;
          this.pinned = result.Pinned

          if (result.Pinned != null && result.Pinned.length > 0) {
            this.showPinned = true;
            this.rotatedPinIcon = "rotated"
          }

          this.loadingList = false;
          this.loading = false;
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingList = false;
            this.loading = false;
          });
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }

  filterSubmittedBy() {
    this.loadTickets();
  }

  filterTicketName() {
    this.loadTickets();
  }

  updatePinnedTickets(ticket: SupportTicketViewModel | undefined) {
    if (ticket == null) {
      return this.alertService.error("There is no ID associated with this ticket.");
    }
    var model = {
      id: ticket.ID
    }
    this.apiService.SetPinned({ body: model })
      .forEach(
        (result) => {
          this.refreshTickets();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  truncatePinnedSubject(subject: string | null | undefined) {
    if (subject != null && subject.length < 32) {
      return subject;
    }
    else {
      var newString = subject?.slice(0, 29) + "..."
      return newString;
    }
  }
  truncatePinnedUserName(name: string | null | undefined) {
    if (name != null && name.length < 14) {
      return name;
    }
    else {
      var newString = name?.slice(0, 11) + "..."
      return newString;
    }
  }

  changeData(event: any) {
    console.log("closed = " + this.closed);
  }

  expandAll() {
    this.expandedRows = this.list?.Result.reduce((acc: any, p: any) => (acc[p.ID] = true) && acc, {});
  }

  collapseAll() {
    this.expandedRows = {};
  }

  onRowExpand(event: TableRowExpandEvent) {
    //this.alertService.info(event.data);
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    // this.alertService.info(event.data);
  }

  selectedAll() {
    this.selectedItems = this.list?.Result;
  }

  selectedNone() {
    this.selectedItems = [];
  }

  onSelectionChange(event: any) {
  }

  toggleFilter() {
    this.showFilter = !this.showFilter;
  }

  togglePinned() {
    this.rotatedPinIcon = (this.rotatedPinIcon === 'default' ? 'rotated' : 'default');
    this.showPinned = !this.showPinned;
  }

  openTicket(id: number | undefined) {
    if (!id) {
      return;
    }
    this.doSetRead(id);
    const url = this.router.serializeUrl(this.router.createUrlTree(['tickets/' + id]));
    window.open(url, "_blank");
  }

  doSetRead(id: number) {
    var model = {
      id: id
    }
    this.apiService.SetTicketRead({ body: model })
      .forEach(
        (result) => {
          this.refreshTickets();
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
          });
  }

  getSupportTicketTypeClass(item: SupportTicketViewModel | undefined) {

    if (item?.SupportTicketTypeID == 4) //  Urgent
      return 'text-danger fw-bolder bg-dark';
    if (item?.SupportTicketTypeID == 3) // Report a bug
      return 'text-info fw-bolder  ';
    if (item?.SupportTicketTypeID == 1) // General
      return 'text-primary';
    if (item?.SupportTicketTypeID == 2) // How do I...?
      return 'text-info fst-italic';

    return '';
  }
  getTimeFromNow(date: Date) {
    if ((new Date().getTime()) - (new Date(date).getTime()) > 1000 * 60 * 60 * 36) {
      return formatDate(date, 'shortDate', 'en-US');
    }
    return Utils.getTimeFromNow(date);
  }
  formatMountainTime(date: Date) {

    return Utils.formatMountainTime(date);
  }


  showLinkGitHub(item: SupportTicketViewModel | undefined) {

    if (item?.GitHub_IssueNumber) {
      var url = `https://github.com/UTBS/${item?.GitHub_Repository}/issues/${item?.GitHub_IssueNumber}`;
      var w = window.open(url);
      if (!w)
        location.href = url;
      return;
    }

    this.selectedItems = [item!];
    this.showLinkGitHubSelected();

  }

  showLinkGitHubSelected() {

    if (!this.selectedItems || this.selectedItems.length == 0) {
      this.alertService.error('Please select an item first');
      return;
    }


    this.gitHubIssueVisible = true;

    this.gitHubSelectedItems = this.selectedItems;

    if (!this.gitHubIssues) {
      this.loadingGitHubIssue = true;
      this.apiService.GetGitHubIssues()
        .forEach((result) => {
          this.loadingGitHubIssue = false;
          result.splice(0, 0, { title: 'New Issue', number: 0, repository: 'utbs_optomiser' });

          this.gitHubIssues = result;

          var myTitle = (this.selectedItems?.length) ? (this.selectedItems[0].Subject || '') : '';
          var r = result.find(x => x.title && myTitle.startsWith(x.title))
          if (!r)
            r = result[0];

          this.gitHubIssue = r;

        }).catch(
          err => {
            this.loadingGitHubIssue = false;
            this.alertService.error(Utils.getAjaxError(err));
          });
    } else {
      var myTitle = (this.selectedItems?.length) ? (this.selectedItems[0].Subject || '') : '';
      var r = this.gitHubIssues.find(x => x.title && myTitle.startsWith(x.title))
      if (r)
        this.gitHubIssue = r;
    }

  }


  linkGitHub() {
    if (!this.gitHubSelectedItems || !this.gitHubSelectedItems.length || !this.gitHubIssue)
      return;
    console.debug(this.gitHubIssue);

    let ids = this.gitHubSelectedItems.map((item) => item.ID || 0);

    this.loading = true
    this.apiService.LinkGitHubIssue({
      body: {
        IDs: ids,
        GitHub_IssueNumber: this.gitHubIssue.number,
        GitHub_Repository: this.gitHubIssue.repository || undefined,
        comment: this.gitHubComment || undefined
      }
    })
      .forEach((result) => {
        this.loading = false;
        this.gitHubIssueVisible = false;
        this.loadTable(null);
        this.refreshTickets();
        this.alertService.success('Item linked successfully');


        if (!this.gitHubIssue?.number && result.number) {
          var url = `https://github.com/UTBS/${result?.repository}/issues/${result?.number}`;
          var w = window.open(url);
          if (!w)
            location.href = url;
          return;
        }

      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });
  }

}
